<template>
  <!-- <div :class="className" :style="{ height: height, width: width }"></div> -->
  <div :class="className" :style="{ width: '100%', height: '100%' }" />
</template>

<script>
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";

const animationDuration = 6000;

export default {
  mixins: [resize],
  props: {
    itemData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "100%"
    },
    color: {
      type: String,
      default: "#0AD1FC"
    },
    color2: {
      type: String,
      default: "rgba(16, 161, 221, 0)"
    }
  },

  data() {
    return {
      chart: null
    };
  },
  mounted() {
    if (this.itemData && this.itemData.viewId) {
      this.getChartData(this.itemData.viewId);
    } else {
      this.$nextTick(() => {
        this.initChart();
      });
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    async getChartData(viewId) {
      const { data } = await this.$api.getChartData({
        id: viewId
      });
      const { legend, seriesDataList, xAxisData } = data;
      let series = seriesDataList.map((el, i) => {
        console.log(i, seriesDataList.length - 2);
        if (i >= seriesDataList.length - 1) {
          return {
            name: el.name,
            type: "line",
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function(value) {
                return value + " °C";
              }
            },
            data: el.dataList
          };
        } else {
          return {
            name: el.name,
            type: "bar",
            barWidth: 7.5, // 柱子宽度
            itemStyle: {
              normal: {
                //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
                barBorderRadius: [10, 10, 0, 0]
              }
            },
            tooltip: {
              valueFormatter: function(value) {
                return value + " ml";
              }
            },
            data: el.dataList
          };
        }
      });
      console.log("series", series);
      this.initChart(legend, series, xAxisData);
    },

    initChart(legend = null, series = null, xAxisData = null) {
      this.chart = echarts.init(this.$el, "macarons");

      let option = {
        // backgroundColor: "#0F224C",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999"
            }
          }
        },
        // toolbox: {
        //   feature: {
        //     dataView: { show: true, readOnly: false },
        //     magicType: { show: true, type: ["line", "bar"] },
        //     restore: { show: true },
        //     saveAsImage: { show: true }
        //   }
        // },
        // legend: {
        //   data: legend || ["Evaporation", "Precipitation", "Temperature"]
        // },
        // color: ["#10A1DD", "#FFB502"],
        grid: {
          left: "0%",
          right: "0%",
          top: "0%",
          bottom: "0%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: xAxisData || ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
            axisPointer: {
              type: "shadow"
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            // name: "Precipitation",
            min: 0,
            // max: 250,
            interval: 50,
            // axisLabel: {
            //   formatter: "{value} ml"
            // },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              formatter: function() {
                return "";
              }
            }
          },
          {
            type: "value",
            // name: "Temperature",
            min: 0,
            // max: 25,
            // interval: 5,
            // axisLabel: {
            //   formatter: "{value} °C"
            // },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              formatter: function() {
                return "";
              }
            }
          }
        ],
        series: series || [
          {
            // name: "Evaporation",
            type: "bar",
            barWidth: 7.5, // 柱子宽度
            itemStyle: {
              normal: {
                //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
                barBorderRadius: [10, 10, 0, 0]
              }
            },
            tooltip: {
              valueFormatter: function(value) {
                return value + " ml";
              }
            },
            data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3]
          },
          {
            // name: "Precipitation",
            type: "bar",
            barWidth: 7.5, // 柱子宽度
            itemStyle: {
              normal: {
                //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
                barBorderRadius: [10, 10, 0, 0]
              }
            },
            tooltip: {
              valueFormatter: function(value) {
                return value + " ml";
              }
            },
            data: [2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3]
          },
          {
            // name: "Temperature",
            type: "line",
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function(value) {
                return value + " °C";
              }
            },
            data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2]
          }
        ]
      };

      this.chart.setOption(option);
    }
  }
};
</script>
